import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="bg-background-100 rounded-2xl p-8 md:p-12">
          <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-5">
            <i className="ri-book-read-line text-4xl text-primary-500"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            准备开始阅读了吗？
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-lg mx-auto leading-relaxed">
            立即探索继母的朋友们漫画的精彩世界，获取完整剧情解读、角色分析与阅读指南
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/plot"
              className="px-6 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              浏览剧情介绍
            </Link>
            <Link
              to="/category/characters"
              className="px-6 py-3 bg-secondary-500 text-background-50 rounded-md font-medium text-sm hover:bg-secondary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              查看角色解析
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}